<template>
    <span class="j-label-root">
        <span v-if="required === true" class="j-required text-rose-500">*</span>
        <slot />
    </span>

</template>

<script setup>
defineProps({
    required    : {
        type        : Boolean,
        default     : false,
    }
});
</script>
